import { Chip, Grid } from "@mui/material";
import { IServiceDeviceData } from "../../../store/api/devices/types";
import { getAlarmsStatusCount } from "../../../components/Nodes/helpers";
import { Icon } from "../../../components/Shared/Icon";

interface ITableRow {
    tableRow: IServiceDeviceData,
}

const alarmIcons: Record<string, { name: string; className: string }> = {
    Critical: { name: "error", className: "text-destructive" },
    Major: { name: "error_outline", className: "text-warning" },
};

const AlarmsStatus: React.FC<ITableRow> = ({ tableRow }) => {

    const { status, count } = getAlarmsStatusCount(tableRow);
    const iconConfig = alarmIcons[status];
    return (
        <>
            {count > 0 ? <Grid container columnSpacing={2} flexDirection={"row"} justifyContent={"flex-start"} alignItems={"center"}>
                <Grid item display="flex">
                    {iconConfig && <Icon name={iconConfig.name} size={18} className={iconConfig.className} />}
                </Grid>
                <Grid item sx={{ color: "var(--foreground)", fontSize: "var(--font-size-sm)" }}>{status}</Grid>
                <Grid item>
                    <Chip
                        size="small"
                        label={count}
                        sx={{ backgroundColor: "var(--secondary)", color: "var(--secondary-foreground)", fontSize: "var(--font-size-xs)" }}
                    />
                </Grid>
            </Grid> : "-"}

        </>
    );
}
export default AlarmsStatus;